import { useMemo } from "react";

import { IHomepageMainNavItems } from "../../../types/working-model";
import MarketingRegisteredAgenda from "./marketing-registered-agenda/marketing-registered-agenda";
import { MarketingRegisteredPage as MarketingRegisteredHome } from "./marketing-registered-page";
import Leaderboard from "./leaderboard/leaderboard";

function getComponent(tabName: string): JSX.Element {
	switch (tabName.toUpperCase()) {
		case 'HOME': return <MarketingRegisteredHome />;
		case 'SESSIONS': return <MarketingRegisteredAgenda />;
		case 'LEADERBOARD': return <Leaderboard />;
		default: return <MarketingRegisteredHome />;
	}
}

/**
 * Handles hooks that were previously inside MarketingRegisteredRoutes:
 * - language redirect
 * - translation modules
 * - socket announcement listener (registered-* room)
 * - invalid-translation redirect effect
 *
 * Returns the component map for dynamic nav item routes.
 */
export default function useMarketingPageSetup(eventMainNavItems: IHomepageMainNavItems[] | undefined): {
	MarketingRegisteredComponentMap: Record<string, JSX.Element>;
} {

	const MarketingRegisteredComponentMap = useMemo(() => {
		if (eventMainNavItems) {
			return eventMainNavItems.reduce((a: Record<string, JSX.Element>, c: IHomepageMainNavItems) => {
				a[c.name] = getComponent(c.name);
				return a;
			}, {});
		}
		return {};
	}, [eventMainNavItems]);

	return { MarketingRegisteredComponentMap };
}
